export const environment = {
    production: false,
    env: 'demo',
    apiUrl: 'https://demo-api-holista.noveltytechnology.com/api',
  }